import { array, boolean, number, object, string, } from 'yup';
export const basketObject = {
    acceptTerms: boolean(),
    gift_voucher: string(),
    Items: array(object({
        ProductId: number().required(),
    })),
    Upsells: array(object({
        UpsellId: number().required(),
    })),
    Misc: array(object({
        MiscellaneousId: number().required(),
    })),
};
export const basketSchema = object(basketObject);
